<template style="overflow-y: hidden">
  <div :class="['background',this.$store.state.showBottom ?'home1':'home']"  @click="changeShow()">
      <div style="width: 100%;height:100%;display: flex ;align-items: center;justify-content: center;justify-items: center;" v-if="!this.$store.state.showBottom">
        <div>
<!--          <div class="home-banner-1" style="margin-top: 38rem"></div>-->
          <div class="home-banner-2" style="margin-top: 40rem;cursor: pointer" :style="{color:color?'#3775ec':'',opacity:color?'0.9':'0.6'}" @mouseenter="changeColor()" @mouseleave="changeColor()">欢迎进入内投集团 <i class="el-icon-d-arrow-right"></i></div>
        </div>
      </div>
    <div class="news" id="myElement" v-if="this.$store.state.showBottom">
      <div style="background-color: white;width: 70%;margin-left: 15%;padding-top: 2rem" >
        <div class="video">
          <div style="height: 100%;width: 40%;margin-left: 3%">
            <div class="title">内投风采</div>
            <div style="display: flex">
              <div class="name">N T SHOW</div>
              <div style="width: 70%">
                <el-divider></el-divider>
              </div>
            </div>
            <div style="line-height: 200%">
              内江投资控股集团有限公司（简称“内投集团公司”）成立于2008年7月，是市委市政府深化投融资体制改革，进一步增强集中财力、整合资源、攻坚破难办大事的能力、有效改善金融生态环境，缓解基础设施建设投人不足及中小企业融资困难等瓶颈制约，按照7.15亿元注册资本规模组建的一家AA+级信用评级国有控股企业。
              <div style="color: #234C9C;cursor: pointer; margin-left: 88%" @click="toAbout()">
                MORE
              </div>
            </div>
          </div>
          <div style="width: 52%;height:100%;margin-left: 3%">
            <video ref="video"
                   :src="videoSrc"
                   style="width: 101%;height:100%;object-fit: cover"  controls autoplay >
            </video>
          </div>

        </div>
        <div style="width: 100%;height: 0.6rem;background-color: #efefef"></div>
        <diV class="news-title">
          <el-divider border-style="dashed"> 集团要闻 </el-divider>
        </diV>
        <!--      <div  :class="'news-details'" @mouseover="changeShadow(item)" v-for="item in dataList" :key="item.id">-->
        <div  :class="['news-details',item.isHovered ? 'hover-shadow':'']" @click="toDetails(item)" @mouseenter="changeShadow(item)" @mouseleave="changeShadow(item)" v-for="item in dataList" :key="item.id">
          <div class="details">
            <div style="display: flex;align-items: center">
            <div class="details_title"
                 :style="{
              fontSize :item.isHovered ? '1.2rem':'',
              color:item.isHovered ? '#1196db':''
            }"
                 v-bind:title="item.title">
              {{item.title}}
            </div>
            <div style="padding-left: 1rem">
              <i v-if="item.haveVideo" class="el-icon-video-pause" style="font-size: 1.0rem"/>
              <i v-if="item.haveImage" class="el-icon-picture" style="font-size: 1.0rem"/>
            </div>
            </div>
            <div style="margin-top: 2%;width: 80%;font-size: 0.8rem; font-weight: 100;color: #bfbfbf;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" v-bind:title="item.summary">{{item.summary}}</div>
          </div>
          <div class="details-button"  :style="{
              color:item.isHovered ? '#1196db':''
            }">点击详情
          </div>
        </div>
        <div style="width: 100%;text-align: center">
          <el-pagination
              background
              style="text-align: center"
              layout="prev, pager, next"
              :total="total"
              :current-page="queryParams.pageNum"
              :page-size="queryParams.pageSize"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'

import {getArticleList} from "@/api/article";

export default {
  data() {
    return {
      videoSrc:process.env.VUE_APP_BASE_API+'/2024/video/01.mp4',
      haveVideo: require('@/assets/haveImageAndVideo/video.png'),
      haveImage: require('@/assets/haveImageAndVideo/image.png'),
      color:false,
      top:0,
      isShow:this.$store.state.showBottom,
      isHovered: false,
      bannerSrc:require('@/assets/image/background/banner.png'),
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        category:1,
        status:true
      },
      total:undefined,
      dataList:[],
    }
  },
  name: 'HomeView',
  components: {},
  mounted() {
   this.getList()
    this.$store.commit('SET_SHOW_BOTTOM',false)
    // window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置到 Vue Router 的 meta 字段
    if (this.$el) {
      from.meta.savedPosition = {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    next();
  },
  methods: {
    del(){
      const element = document.getElementById('myElement');
      if(element.classList.length>0){
        element.classList.remove('news');
      }

    },
    // handleScroll(e) {
    //   const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //   const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    //   const scrollTop = window.scrollY
    //   if (scrollTop + windowHeight >= scrollHeight-200) {
    //     this.isShow=true
    //     this.$refs.home.scrollTop = 0;
    //   }
    //   if(scrollTop<=5){
    //     e.preventDefault();
    //   }
    // },
    changeColor(){
      this.color=!this.color
    },
    changeShow(){
      this.color=false
      this.$store.commit('SET_SHOW_BOTTOM',true)
      setTimeout(()=>{
        this.del()
      },2000)
    },
    changeShadow(item) {
      item.isHovered = !item.isHovered;
    },
    toAbout(){
      this.$router.push('/about')
    },
    toDetails(item){
      item.isHovered=false
      this.$router.push({path:"/news/details",query:{id:item.id}})
    },
    handleCurrentChange(pageNum){
      this.queryParams.pageNum=pageNum
      this.getList()
    },
      getList(){
        getArticleList(this.queryParams).then(async res=>{
          const data= await res.data.content
          for (let i = 0; i <data.length ; i++) {
              data[i].isHovered=false
          }
          this.dataList= data
          this.total=res.data.totalElements
        })
      }
  }
}
</script>

<style scoped>
.home-banner-1{
  color: white;
  font-size: 1.2rem;
  text-align: center;
  animation: rightToLeft 3s;
}
.home-banner-2 {
  /*height: ;*/
  /*width: 90vw;*/
  color: #ffffff;
  font-size: 2rem;
  text-align: center;
  font-weight: bold;
  line-height: 90px;
  font-family: 'Microsoft YaHei';
  animation: rightToLeft 3s;
}
.hover-shadow {
  /* 鼠标悬停时的阴影效果 */
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
}
.details_title{
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60%;
  cursor: pointer;
  font-weight: bold;
}
.video{
  display: flex;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 320px;
}
.el-divider__text{
  font-size: 28px;
  font-weight: bold;
  color: #234C9C;
}
.home{

  width: 100%;
  height: 100vh;
  /*overflow: hidden;*/
}
.background{
  background-size: 100vw 100vh;
  background-image: url("@/assets/image/background/banner.png");
  background-position: top left;
  background-repeat: no-repeat;
}
.home1{
  width: 100%;
  overflow: hidden;
  /*overflow: hidden;*/
  /*height: 100vh;*/
}
.news{
  animation: downToTop 2s;
  animation-fill-mode: forwards;
}
#myElement{
  padding-top: 4rem;
  width: 100%;
  /*min-height: 600px;*/
  background-color: #efefef;
}
.news-title{
  height: 80px;
  font-size: 20px;
  font-weight: 1000;
  display: flex;
  align-items: center; /* 竖直居中 */
}
.news-details{
  height: 120px;
  cursor: pointer;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 竖直居中 */
  border-bottom: 1px #eaeaea solid
}
.details{
  margin-top: 10px;
  height: 100px;
  width: 90%;
  margin-left: 2%;
}
.details-button {
  display: flex;
  cursor: pointer;
  color: #323233;
  font-size: 11px;
  font-family: "SourceHanSans-Regular";
}
.title {
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 30%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 2%;
}
@keyframes downToTop {

  0% {
    transform: translateY(50%);
    opacity: 0;
  }
  1% {
    transform: translatey(50%);
  }

}
@keyframes rightToLeft {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  1% {
    transform: translateX(100%);
  }

  80% {
    transform: translateX(-10%);
  }

  0% {
    transform: translateX(-50%);
  }
}
</style>
